// POSTs JSON to one of the /api functions and normalises every outcome into
// { ok, error, fieldErrors } so forms only handle one shape.
export async function submitForm(url, payload, { timeoutMs = 30000 } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });

    let body = {};
    try {
      body = await response.json();
    } catch {
      // Non-JSON response (e.g. a 404 page or a gateway error)
    }

    if (response.ok && body.ok) return { ok: true, error: null, fieldErrors: {} };

    let error = body.error;
    if (!error && response.status === 413) error = "The attached file is too large.";
    if (!error) error = "Something went wrong. Please try again, or contact us by phone or email.";
    return { ok: false, error, fieldErrors: body.fieldErrors || {} };
  } catch (err) {
    return {
      ok: false,
      error:
        err.name === "AbortError"
          ? "The request timed out. Please check your connection and try again."
          : "We couldn't reach the server. Please check your connection and try again.",
      fieldErrors: {},
    };
  } finally {
    clearTimeout(timer);
  }
}

// Converts bytes to base64 in chunks so large files don't overflow the call stack.
export function bytesToBase64(bytes) {
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return window.btoa(binary);
}
